export const frontTechs = [
  {
    id: 1,
    name: "HTML",
    image: "https://img.icons8.com/color/1x/html-5.png",
    color: "rgba(214,103,13,1)",
  },
  {
    id: 2,
    name: "CSS",
    image: "https://img.icons8.com/color/1x/css3.png",
    color: " rgba(66,54,194,1)",
  },
  {
    id: 3,
    name: "Javascript",
    image: "https://img.icons8.com/color/1x/javascript.png",
    color: " rgba(242,228,39,1)",
  },
  {
    id: 4,
    name: "React",
    image: "https://img.icons8.com/color/1x/react-native.png",
    color: " rgba(53,184,175,1)",
  },
  {
    id: 5,
    name: "Chakra UI",
    image: "https://img.icons8.com/color/1x/chakra-ui.png",
    color: " rgba(47,177,189,1)",
  },
  {
    id: 6,
    name: "Redux",
    image: "https://img.icons8.com/color/1x/redux.png",
    color: "rgba(116,33,204,1)",
  },
  {
    id: 7,
    name: "Typescript",
    image: "https://img.icons8.com/color/1x/typescript.png",
    color: " rgba(66,54,194,1)",
  },

  
];
export const backendTechs = [
  {
    id: 1,
    name: "Node.js",
    image: "https://img.icons8.com/color/1x/nodejs.png",
    color: "rgba(111,163,111,1)",
  },
  {
    id: 2,
    name: "Express.js",
    image: "https://img.icons8.com/fluency/1x/express-js.png",
    color: "rgba(150,156,158,1)",
  },
  {
    id: 3,
    name: "MogoDB",
    image: "https://img.icons8.com/color/1x/mongodb.png",
    color: "rgba(45,133,45,1)",
  },
  {
    id: 4,
    name: "Moongoose",
    image: "https://img.icons8.com/color/1x/mongoose.png",
    color: "rgba(227,98,117,1)",
  },
  {
    id: 5,
    name: "Firebase",
    image: "https://img.icons8.com/color/1x/firebase.png",
    color: "rgba(227,217,73,1)",
  },
  // {
  //   id: 5,
  //   name: "NPM",
  //   image: "https://img.icons8.com/color/1x/npm.png",
  //   boxShadow: "rgba(227,98,117,1)",
  // },
 
];
